import {
  IcFunctionAddPrice,
  IcInventory,
  IcPaymentMethod,
  Tabs,
} from '@fozito/common-ui';
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';

import IcProductSale from '../../assets/icons/tab-product-sale.svg';
import IcProductSaleActive from '../../assets/icons/tab-product-sale-active.svg';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Content = styled.div`
  flex: 1;
`;

const ReportLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const shopId = storage.shop_id.get();

  const tabs = [
    {
      key: 'revenue',
      label: 'REVENUE',
      activeIcon: <IcFunctionAddPrice fill='white' />,
      inactiveIcon: <IcFunctionAddPrice fill='#777D7C' />,
    },
    {
      key: 'payment-method',
      label: 'PAYMENT METHOD',
      activeIcon: <IcPaymentMethod fill='white' />,
      inactiveIcon: <IcPaymentMethod fill='#777D7C' />,
    },
    {
      key: 'product-sale',
      label: 'PRODUCT SALE',
      activeIcon: <img src={IcProductSaleActive}/>,
      inactiveIcon: <img src={IcProductSale}/>,
    },
    {
      key: 'inventory',
      label: 'INVENTORY',
      activeIcon: <IcInventory fill='white' />,
      inactiveIcon: <IcInventory fill='#777D7C' />,
    },
  ];

  const pathToKey: Record<string, string> = {
    [`/store/${shopId}/report`]: 'revenue',
    [`/store/${shopId}/report/payment-method`]: 'payment-method',
    [`/store/${shopId}/report/sale`]: 'product-sale',
    [`/store/${shopId}/report/inventory`]: 'inventory',
  };

  const keyToPath: Record<string, string> = Object.entries(pathToKey).reduce(
    (acc, [path, key]) => ({
      ...acc,
      [key]: path,
    }),
    {}
  );

  const activeKey = pathToKey[location.pathname];

  const handleTabChange = (key: string) => {
    navigate(keyToPath[key]);
  };

  return (
    <Container>
      {activeKey && (
        <Tabs
          items={tabs}
          activeKey={activeKey}
          onChange={handleTabChange}
          height={50}
          minWidth={250}
        />
      )}
      <Content>
        <Outlet />
      </Content>
    </Container>
  );
};

export default ReportLayout;
